import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { Circle } from 'page/catalog/Circle/Circle'
import { userModal } from 'page/catalog/UserModal/store/UserModalStore'
import css from './FailStep.module.scss'

export const FailStep = observer(() => {
  const { error } = userModal.it

  const onClose = useLatestCallback(async () => {
    userModal.close()
  })

  return <Vertical gap={16}>
    <Vertical gap={16} pad={16} center>
      <Space>
        <Circle size={64} icon="person" />
        <Space className={css.fail}>
          <Icon size={16} name="close" />
        </Space>
      </Space>
      {error ? <Typo size={13} one medium upper center>
        {error}
      </Typo> : <Vertical gap={8}>
        <Typo size={13} one medium upper center>
          {i18n('SomethingWentWrong')}
        </Typo>
        <Typo size={13} one secondary center>
          {i18n('PleaseTryAgainLater')}
        </Typo>
      </Vertical>}
    </Vertical>
    <Button height={48} outline action={onClose}>
      {i18n('Close')}
    </Button>
  </Vertical>
})
